/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AssetsSearchEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const assetsSearchEntryPoint: EntryPoint<AssetsSearchEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<AssetsSearchEntryPointComponent>(
			/* webpackChunkName: "assets-app-search" */ './AssetsAppSearchEntrypointWrapper.tsx',
		),
		getPreloadProps: () => ({}),
	});
